import { View, Text, StyleSheet, ScrollView, ActivityIndicator } from 'react-native'
import React, { useState } from 'react'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import BodySignUpScreen from './BodySignUpScreen'

const SignUpScreen = () => {
    const [isLoading1, setIsLoading1] = useState(false)

    if (isLoading1) {
        return (
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <ActivityIndicator size={'large'} />
            </View>
        )
    }
    return (
        <View style={{ backgroundColor: 'white' }}>
            {/* <TopHeaderComponent /> */}

            <ScrollView contentContainerStyle={{ flexGrow: 1, paddingBottom: '35%', }}>

                <BodySignUpScreen isLoading1={isLoading1} setIsLoading1={setIsLoading1} />
            </ScrollView>
        </View>
    )
}

const styles = StyleSheet.create({

})

export default SignUpScreen